/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:53:03]
Permissions to update outside the main branch: [false]
*/

import {
    PartialRecord,
    toDisplayRoleType,
    ValidatedDropDownList,
    ValidatedInput,
    ValidatedRadioButton,
} from '@finbeat/react-toolkit';
import { RoleFilter as RoleFilterType, RoleType } from 'models/api/roles';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { UseQueryResult } from 'react-query';
import { Col, FormGroup, Row } from 'reactstrap';

type RoleFilterPropOptions = PartialRecord<
    keyof RoleFilterType,
    {
        hide?: true;
    }
>;

export type RoleFilterFormProp = {
    roleTypes: RoleType[];
    getRoleTypesQuery: UseQueryResult<RoleType[], unknown>;
    filterOptions?: RoleFilterPropOptions;
};

const RoleFilter = ({ roleTypes, getRoleTypesQuery, filterOptions }: RoleFilterFormProp) => {
    const { t } = useTranslation();

    const roleTypeList = useMemo(
        () =>
            roleTypes.length
                ? roleTypes.map((x) => ({ id: x.id, name: toDisplayRoleType(x.code, t) }))
                : [],
        [roleTypes]
    );

    return (
        <>
            <Row>
                <Col>
                    <ValidatedInput<RoleFilterType>
                        id="ds-name"
                        name="name"
                        label={t('BackOfficeCode')}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <ValidatedInput<RoleFilterType>
                        id="ds-nameTranslation"
                        name="displayName"
                        label={t('BackOfficeName')}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <ValidatedInput<RoleFilterType>
                        id="ds-dsc"
                        name="dsc"
                        label={t('BackOfficeDescription')}
                    />
                    <div className="mb-3">
                        <ValidatedRadioButton<RoleFilterType>
                            name="isActive"
                            items={[
                                {
                                    id: null,
                                    label: t('BackOfficeAll'),
                                },
                                {
                                    id: true,
                                    label: t('BackOfficeIsActive'),
                                },
                                {
                                    id: false,
                                    label: t('BackOfficeInactive'),
                                },
                            ]}
                        />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <ValidatedInput<RoleFilterType>
                        id="ds-show-technical"
                        name="showTechnical"
                        type="checkbox"
                        label={t('BackOfficeShowTechnicalRoles')}
                    />
                </Col>
            </Row>
            {!filterOptions?.typeId?.hide && (
                <Row>
                    <Col>
                        <FormGroup>
                            <ValidatedDropDownList<RoleFilterType>
                                name="typeId"
                                label={t('BackOfficeType')}
                                items={roleTypeList}
                                isLoading={getRoleTypesQuery.isFetching}
                            />
                        </FormGroup>
                    </Col>
                </Row>
            )}
        </>
    );
};

export default RoleFilter;
